module.exports = __webpack_public_path__ + "83497e667f9dc924d52fb5fb7837a72c.svg";